import useMediaQuery from "hooks/useMediaQuery"
import theme from "styles/theme"
import { useMemo } from "react"

export default () => {
  const mobile = useMediaQuery(theme.mobile)
  const tablet = useMediaQuery(theme.tablet)
  const desktop = useMediaQuery(theme.desktop)

  return useMemo(() => ({ mobile, tablet, desktop }), [mobile, tablet, desktop])
}
